export default __webpack_public_path__ + "static/media/another_booking.ff9eed68.svg";